export default "__VITE_ASSET__fe548549__"